import { useEffect, useState } from 'react';
import { Course } from "../model/course";
import { UserCertification} from "../model/certification";
import { RootState } from "../reducers/store";
import { AlertView } from './alert';

import { useSelector } from "react-redux";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { User } from '../model/user';
import { Program } from '../model/program';
import { UserCertCourseRow } from './usercertcourse';
import { Tooltip } from '@mui/material';

export const UserCertificationView = () => {   
    const [errorMessage, setError] = useState<string | null>(null);
    const [currentCourses, setCurrentCourses] = useState<Course[]>([]);
    const [usersWithoutData, setUsersWithoutData] = useState<User[]>([]);

    const currentProgram: Program | null = useSelector((state: RootState) => state.programs.currentProgram);
    const currentGroupUsers: User[] = useSelector((state: RootState) => state.users.currentGroupUsers);
    const allCourses: Course[] = useSelector((state: RootState) => state.courses.courses);
    const currentUserCertifications: UserCertification[] | null = useSelector((state: RootState) => state.certifications.currentUserCertifications);
    
    const refreshViewData = async () => {
        if (!currentProgram) {
            setError("could not get current program");
            return;
        }

        let courses = getCurrentProgramCourses(currentProgram, allCourses);
        setCurrentCourses(courses);

        if (currentUserCertifications == null) {
            return
        }

        let startedUserIds: string[] = currentUserCertifications?.map(certification => certification.userId);
        let noDataUsers = currentGroupUsers.filter(user => !startedUserIds.includes(user.id));
        setUsersWithoutData(noDataUsers);
    };

    useEffect(() => {
        refreshViewData();
    }, [currentUserCertifications]);

    const getCurrentProgramCourses = (program: Program | null, courses: Course[]): Course[] => {
        return courses.filter((course) => course.programId == program?.id)
    }

    return (
        <div style={{padding: 16}}>
            <AlertView error={errorMessage}/>
            <Typography sx={{ marginBottom: 2 }} align='left'>Certification progress</Typography>
            <TableContainer component={Paper} sx={{ marginBottom: 5 }} >
                <Table aria-label="collapsible table">
                    <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>
                            <Tooltip title="Certified means the user has passed all assessment quizzes in the program that have a minimum pass threshold">
                                <span style={{ cursor: 'help' }}>
                                    Certified
                                </span>
                            </Tooltip>
                        </TableCell>
                        <TableCell>Passed</TableCell>
                        <TableCell>User</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {
                        currentUserCertifications?.map((userCert) => (
                            userCert.userEmail ? 
                                <UserCertCourseRow 
                                    key={userCert.userId} 
                                    userCert={userCert} 
                                    courses={currentCourses} 
                                />:
                                <></>
                        ))
                    }
                    </TableBody>
                </Table>
            </TableContainer>
            
            {
                currentProgram?.clientName != "Public" ? (
                    <>
                        <Typography sx={{ marginBottom: 2 }} align='left'>No certification data</Typography>
                        <TableContainer component={Paper}>
                            <Table aria-label="regular table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell/>
                                        <TableCell>User</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        usersWithoutData.map((user) => (
                                            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                                <TableCell width={60}></TableCell>
                                                <TableCell>{user.email}</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ): <></>
            }
        </div>
    );
}